/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import { IImageTests } from 'app/shared/model/image-tests.model';
import { ILabTestCategory } from 'app/shared/model/lab-test-category.model';
import { ILabTestItem } from 'app/shared/model/lab-test-item.model';
import { IDiagLabPanel } from 'app/shared/model/diag-lab-panel.model';
import { ITemplatePrescription } from 'app/shared/model/template-prescription.model';
import { TemplateItemType } from 'app/shared/model/enumerations/template-item-type.model';

export interface ITemplateInvestigation {
  id?: string;
  active?: boolean;
  cursor?: number;
  lastUpdated?: number;
  microSec?: number;
  timestampEntry?: number;
  instructions?: string | null;
  templateName?: string;
  forSymptom?: string | null;
  templateItemType?: keyof typeof TemplateItemType | null;
  imageTests?: IImageTests | null;
  category?: ILabTestCategory | null;
  item?: ILabTestItem | null;
  panel?: IDiagLabPanel | null;
  prescription?: ITemplatePrescription | null;
}

export const defaultValue: Readonly<ITemplateInvestigation> = {
  active: false,
};
